import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "x_panel" };
const _hoisted_2 = { class: "x_content" };
const _hoisted_3 = { class: "row" };
const _hoisted_4 = { class: "col-xs-12 col-sm-12 col-md-12" };
const _hoisted_5 = { class: "d-flex bottom10" };
const _hoisted_6 = { class: "x_panel" };
const _hoisted_7 = { class: "x_content" };
const _hoisted_8 = { class: "row" };
const _hoisted_9 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_10 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_11 = { class: "row top10" };
const _hoisted_12 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_13 = { class: "text-muted" };
const _hoisted_14 = { class: "x_panel" };
const _hoisted_15 = { class: "x_content" };
const _hoisted_16 = {
    key: 0,
    class: "table"
};
const _hoisted_17 = {
    key: 0,
    class: "text-muted small"
};
const _hoisted_18 = { class: "x_panel" };
const _hoisted_19 = { class: "x_content" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _a, _b, _c;
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_b_button = _resolveComponent("b-button");
    const _component_b_progress_bar = _resolveComponent("b-progress-bar");
    const _component_b_progress = _resolveComponent("b-progress");
    return (_openBlock(), _createElementBlock("div", null, [
        _createCommentVNode(" DataCollect URL "),
        _cache[40] || (_cache[40] = _createTextVNode()),
        _createElementVNode("div", _hoisted_1, [
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "x_title" }, [
                _createElementVNode("h3", null, "Data Collect")
            ], -1 /* CACHED */)),
            _cache[5] || (_cache[5] = _createTextVNode()),
            _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        _cache[2] || (_cache[2] = _createElementVNode("label", null, "Data Collect URL", -1 /* CACHED */)),
                        _cache[3] || (_cache[3] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_5, [
                            _createVNode(_component_b_form_input, {
                                type: "text",
                                value: _ctx.dataCollectUrl,
                                placeholder: "Not configured",
                                readonly: ""
                            }, null, 8 /* PROPS */, ["value"]),
                            _cache[1] || (_cache[1] = _createTextVNode()),
                            _createVNode(_component_b_button, {
                                class: "m-0 ms-2",
                                type: "button",
                                variant: "primary",
                                disabled: !_ctx.dataCollectUrl,
                                onClick: _ctx.copyDataCollectUrl,
                                title: "Copy to clipboard"
                            }, {
                                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                                        _createElementVNode("i", {
                                            class: "fa fa-clipboard",
                                            "aria-hidden": "true"
                                        }, null, -1 /* CACHED */)
                                    ]))]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["disabled", "onClick"])
                        ])
                    ])
                ])
            ])
        ]),
        _cache[41] || (_cache[41] = _createTextVNode()),
        _createCommentVNode(" Live Performance "),
        _cache[42] || (_cache[42] = _createTextVNode()),
        _createElementVNode("div", _hoisted_6, [
            _cache[11] || (_cache[11] = _createElementVNode("div", { class: "x_title" }, [
                _createElementVNode("h3", null, "Live Performance"),
                _createTextVNode(),
                _createElementVNode("div", { class: "clearfix" })
            ], -1 /* CACHED */)),
            _cache[12] || (_cache[12] = _createTextVNode()),
            _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("label", {
                            class: _normalizeClass({ 'text-danger': _ctx.cpuOverutilised })
                        }, "\r\n                            CPU Usage: " + _toDisplayString(_ctx.formatPercent((_a = _ctx.stats) === null || _a === void 0 ? void 0 : _a.cpuUsagePercent)), 3 /* TEXT, CLASS */),
                        _cache[6] || (_cache[6] = _createTextVNode()),
                        _createVNode(_component_b_progress, {
                            max: 100,
                            variant: _ctx.cpuOverutilised ? 'danger' : 'primary'
                        }, {
                            default: _withCtx(() => {
                                var _a, _b;
                                return [
                                    _createVNode(_component_b_progress_bar, {
                                        value: (_b = (_a = _ctx.stats) === null || _a === void 0 ? void 0 : _a.cpuUsagePercent) !== null && _b !== void 0 ? _b : 0
                                    }, null, 8 /* PROPS */, ["value"])
                                ];
                            }),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["variant"])
                    ]),
                    _cache[8] || (_cache[8] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("label", {
                            class: _normalizeClass({ 'text-danger': _ctx.memoryOverutilised })
                        }, "\r\n                            Memory Usage: " + _toDisplayString(_ctx.formatMemoryGb((_b = _ctx.stats) === null || _b === void 0 ? void 0 : _b.memoryUsedMb)) + " / " + _toDisplayString(_ctx.formatMemoryGb((_c = _ctx.stats) === null || _c === void 0 ? void 0 : _c.memoryTotalMb)), 3 /* TEXT, CLASS */),
                        _cache[7] || (_cache[7] = _createTextVNode()),
                        _createVNode(_component_b_progress, {
                            max: 100,
                            variant: _ctx.memoryOverutilised ? 'danger' : 'primary'
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_b_progress_bar, { value: _ctx.memoryUsedPercent }, null, 8 /* PROPS */, ["value"])
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["variant"])
                    ])
                ]),
                _cache[10] || (_cache[10] = _createTextVNode()),
                _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("small", _hoisted_13, [
                            _cache[9] || (_cache[9] = _createElementVNode("i", { class: "fa fa-clock-o" }, null, -1 /* CACHED */)),
                            _createTextVNode(" Last updated: " + _toDisplayString(_ctx.statsLastUpdatedDisplay), 1 /* TEXT */)
                        ])
                    ])
                ])
            ])
        ]),
        _cache[43] || (_cache[43] = _createTextVNode()),
        _createCommentVNode(" System Information "),
        _cache[44] || (_cache[44] = _createTextVNode()),
        _createElementVNode("div", _hoisted_14, [
            _cache[34] || (_cache[34] = _createElementVNode("div", { class: "x_title" }, [
                _createElementVNode("h3", null, "System Information")
            ], -1 /* CACHED */)),
            _cache[35] || (_cache[35] = _createTextVNode()),
            _createElementVNode("div", _hoisted_15, [
                (_ctx.systemInfo)
                    ? (_openBlock(), _createElementBlock("table", _hoisted_16, [
                        _createElementVNode("tbody", null, [
                            _createElementVNode("tr", null, [
                                _cache[13] || (_cache[13] = _createElementVNode("th", { style: { "width": "30%" } }, "Machine Name", -1 /* CACHED */)),
                                _cache[14] || (_cache[14] = _createTextVNode()),
                                _createElementVNode("td", null, _toDisplayString(_ctx.systemInfo.machineName || 'Unknown'), 1 /* TEXT */)
                            ]),
                            _cache[28] || (_cache[28] = _createTextVNode()),
                            _createElementVNode("tr", null, [
                                _cache[15] || (_cache[15] = _createElementVNode("th", null, "Operating System", -1 /* CACHED */)),
                                _cache[16] || (_cache[16] = _createTextVNode()),
                                _createElementVNode("td", null, _toDisplayString(_ctx.systemInfo.operatingSystem || 'Unknown'), 1 /* TEXT */)
                            ]),
                            _cache[29] || (_cache[29] = _createTextVNode()),
                            _createElementVNode("tr", null, [
                                _cache[17] || (_cache[17] = _createElementVNode("th", null, "Processor", -1 /* CACHED */)),
                                _cache[18] || (_cache[18] = _createTextVNode()),
                                _createElementVNode("td", null, _toDisplayString(_ctx.systemInfo.processor || 'Unknown'), 1 /* TEXT */)
                            ]),
                            _cache[30] || (_cache[30] = _createTextVNode()),
                            _createElementVNode("tr", null, [
                                _cache[19] || (_cache[19] = _createElementVNode("th", null, "Total Memory", -1 /* CACHED */)),
                                _cache[20] || (_cache[20] = _createTextVNode()),
                                _createElementVNode("td", null, _toDisplayString(_ctx.formatMemoryGb(_ctx.systemInfo.totalMemoryMb)), 1 /* TEXT */)
                            ]),
                            _cache[31] || (_cache[31] = _createTextVNode()),
                            _createElementVNode("tr", null, [
                                _cache[21] || (_cache[21] = _createElementVNode("th", null, "Available Disk Space", -1 /* CACHED */)),
                                _cache[22] || (_cache[22] = _createTextVNode()),
                                _createElementVNode("td", null, _toDisplayString(_ctx.systemInfo.availableDiskSpaceGb) + " GB", 1 /* TEXT */)
                            ]),
                            _cache[32] || (_cache[32] = _createTextVNode()),
                            _createElementVNode("tr", null, [
                                _cache[24] || (_cache[24] = _createElementVNode("th", null, "Upload Malware Scanning", -1 /* CACHED */)),
                                _cache[25] || (_cache[25] = _createTextVNode()),
                                _createElementVNode("td", null, [
                                    _createElementVNode("span", {
                                        class: _normalizeClass(_ctx.malwareScanClass)
                                    }, _toDisplayString(_ctx.malwareScanSummary), 3 /* TEXT, CLASS */),
                                    _cache[23] || (_cache[23] = _createTextVNode()),
                                    (_ctx.systemInfo.malwareScannerStatus)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.systemInfo.malwareScannerStatus), 1 /* TEXT */))
                                        : _createCommentVNode("v-if", true)
                                ])
                            ]),
                            _cache[33] || (_cache[33] = _createTextVNode()),
                            _createElementVNode("tr", null, [
                                _cache[26] || (_cache[26] = _createElementVNode("th", null, "Last Updated", -1 /* CACHED */)),
                                _cache[27] || (_cache[27] = _createTextVNode()),
                                _createElementVNode("td", null, _toDisplayString(_ctx.infoLastUpdatedDisplay), 1 /* TEXT */)
                            ])
                        ])
                    ]))
                    : _createCommentVNode("v-if", true)
            ])
        ]),
        _cache[45] || (_cache[45] = _createTextVNode()),
        _createCommentVNode(" Diagnostic Logs "),
        _cache[46] || (_cache[46] = _createTextVNode()),
        _createElementVNode("div", _hoisted_18, [
            _cache[38] || (_cache[38] = _createElementVNode("div", { class: "x_title" }, [
                _createElementVNode("h3", null, "Diagnostics")
            ], -1 /* CACHED */)),
            _cache[39] || (_cache[39] = _createTextVNode()),
            _createElementVNode("div", _hoisted_19, [
                _cache[36] || (_cache[36] = _createElementVNode("p", null, "\r\n                    Download a ZIP archive containing recent application logs and a summary of host information.\r\n                ", -1 /* CACHED */)),
                _cache[37] || (_cache[37] = _createTextVNode()),
                _createVNode(_component_b_button, {
                    variant: "primary",
                    disabled: _ctx.downloadingLogs,
                    onClick: _ctx.downloadLogs
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("i", {
                            class: _normalizeClass(["fa", _ctx.downloadingLogs ? 'fa-spinner fa-spin' : 'fa-download'])
                        }, null, 2 /* CLASS */),
                        _createTextVNode("\r\n                     " + _toDisplayString(_ctx.downloadingLogs ? 'Preparing...' : 'Download Logs'), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["disabled", "onClick"])
            ])
        ])
    ]));
}
